import React from "react";
import styled from "styled-components";
import { Column, Row } from "simple-flexbox";
import { Button } from "@material-ui/core";
import CustomInput from "../../common/components/CustomInput";
import { history } from "../../managers/history";
import Divider from "@material-ui/core/Divider/Divider";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

const Desktop = styled.div`
 @media (min-width: 1025px) {
    display: visible;
    font: bold 16px/22px Open Sans;
    letter-spacing: 0px;
    color: #1f1f1f;
    opacity: 1;
  }
  @media (min-width: 0px) and (max-width: 1024px) {
    display: none;
  }
  
`;

function ResetPasswordForm(props) {
  let {
    state,
    onClose,
    // currentTogglePassword,
    // oldTogglePassword,
    onChangeEvent,
    onResetPasswordClicked,
  } = props;
  const [passwordShown, setPasswordShown] = React.useState(false);
  const [oldPasswordShown, setOldPasswordShown] = React.useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = React.useState(false);
  const currentTogglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const oldTogglePasswordVisiblity = () => {
    setOldPasswordShown(oldPasswordShown ? false : true);
  };
  const confirmTogglePasswordVisiblity = () => {
    setConfirmPasswordShown(confirmPasswordShown ? false : true);
  };
  return (
    <Column className="w-354 pt-2" horizontal={"center"}>
      <Row className="w-100 justify-content-between align-items-center pb-42 fw-900 fs-16">
          
      { window.innerWidth===959?null:<><Desktop>Change Password</Desktop>
    <Desktop>
    <img
    className="cursor-pointer mb-20"
    onClick={() => onClose()}
    src="/images/redCross.svg"
    />
    </Desktop></>}
        
      </Row>

      <form
        onSubmit={(event) => onResetPasswordClicked(event)}
        className="w-100 mt-19"
      >
        {/* <Row className="fs-15 mt-2  select-new-password">Enter Current Password</Row> */}
        {/*    <CustomInput id="oldpassword" type={"password"} value={state ? state.oldpassword : ""}*/}
        {/*                 onChange={onChangeEvent} error={state ? state.oldpasswordError : ""}*/}
        {/*                 className="fs-15 p-2 mt-1 select-password-pop h-35" required={true}/>*/}
        <Row className="fs-15 mt-2  select-new-password">
          Enter Current Password
        </Row>
        <div className="input-border display-flex mt-6 align-items-center bg-rgb32">
          <input
            id="oldPassword"
            type={state && state.isPasswordVisible ? "text" : "password"}
            value={state ? state.oldPassword : ""}
            onChange={onChangeEvent}
            error={state ? state.oldPasswordError : ""}
            className="fs-15 border-0 p-2  h-35 bg-eee w-100 outline-none"
            required={true}
          />
          <span onClick={() => props.currentTogglePassword()} className="mr-13">
            {" "}
            {passwordShown ? (
              <VisibilityIcon
                fontSize="small"
                style={{ color: "#1f1f1f" }}
                onClick={currentTogglePasswordVisiblity}
              />
            ) : (
              <VisibilityOff
                fontSize="small"
                style={{ color: "#1f1f1f" }}
                onClick={currentTogglePasswordVisiblity}
              />
            )}
          </span>
        </div>
        <span className="fc-red">{state.oldPasswordError}</span>
        <span className="fc-red">{state.invalidPassword}</span>
        <Row className="fs-15 margin-t-19  select-new-password">
          Enter New Password
        </Row>
        <div className="input-border display-flex mt-6 align-items-center bg-rgb32">
          <input
            id="password"
            type={state && state.isOldPasswordVisible ? "text" : "password"}
            value={state ? state.password : ""}
            onChange={onChangeEvent}
            error={state ? state.passwordError : ""}
            className="fs-15 border-0 p-2  h-35 bg-eee w-100 outline-none"
            required={true}
          />
          <span onClick={() => props.oldTogglePassword()} className="mr-13">
            {" "}
            {oldPasswordShown ? (
              <VisibilityIcon
                fontSize="small"
                style={{ color: "#1f1f1f" }}
                onClick={oldTogglePasswordVisiblity}
              />
            ) : (
              <VisibilityOff
                fontSize="small"
                style={{ color: "#1f1f1f" }}
                onClick={oldTogglePasswordVisiblity}
              />
            )}
          </span>
        </div>
        <span className="fc-red">{state.passwordError}</span>
        <Row className="fs-15 margin-t-19  confirm-password-pop">
          Confirm New Password
        </Row>
        <div className="input-border display-flex mt-6 align-items-center bg-rgb32">
          <input
            id="confirmPassword"
            type={state && state.isConfirmPasswordVisible ? "text" : "password"}
            value={state ? state.confirmPassword : ""}
            onChange={onChangeEvent}
            error={state ? state.confirmPasswordError : ""}
            className="fs-15 border-0 p-2  h-35 bg-eee w-100 outline-none"
            required={true}
          />
          <span onClick={() => props.confirmTogglePassword()} className="mr-13">
            {" "}
            {confirmPasswordShown ? (
              <VisibilityIcon
                fontSize="small"
                style={{ color: "#1f1f1f" }}
                onClick={confirmTogglePasswordVisiblity}
              />
            ) : (
              <VisibilityOff
                fontSize="small"
                style={{ color: "#1f1f1f" }}
                onClick={confirmTogglePasswordVisiblity}
              />
            )}
          </span>
        </div>
        <span className="fc-red">{state.passwordError}</span>
        <Row className="w-100 justify-content-center mt-61 ">
          <button
            type="submit"
            className="bg-blue outline-none text-transform-capitalize border-0 br-4
                fc-white w-100 py-2 fs-17 mt-4 cursor-pointer reset-btn-password-popup h-41 max-width"
          >
            Reset Password
          </button>
        </Row>
      </form>
    </Column>
  );
}

function ResetComponentPassword(props) {
  // let { state, togglePassword, onChangeEvent, onResetPasswordClicked } = props;
  return (
    <Row className="align-items-center" horizontal={"center"}>
      {ResetPasswordForm(props)}
    </Row>
  );
}

function HeaderComponent(props) {
  return (
    <Row vertical="center" className="justify-content-between w-100">
      <Row vertical="center"></Row>
    </Row>
  );
}

export default ResetComponentPassword;
